module.exports = __webpack_public_path__ + "img/xcancel.840a5307.svg";